import Profile from './ProfileContainer';

export default Profile;
